import { Driver, Unit } from '../database/models';
import { Device } from './Device';

type StatusArrayType = {
  [key in 0 | 1 | 2 | 3]: number[];
} & {
  perc0: number;
  perc1: number;
  perc2: number;
  perc3: number;
};

const defaultStatusArray: StatusArrayType = {
  0: [],
  1: [],
  2: [],
  3: [],
  perc0: 0,
  perc1: 0,
  perc2: 0,
  perc3: 0,
};

export class DeviceService {
  public type: string;
  public uid_parent = 0;
  public devices: number[];
  public childrenDevices: Device[] = [];
  public childrenServices: Unit[] = [];
  public services: number[] = [];
  public drivers: Driver[] = [];
  public tag: string;
  public uid_site: number;
  public uid: number;
  public label: string;
  public totalDevice: number;
  public totalUsedDevice: number;
  public statusArray: StatusArrayType = { ...defaultStatusArray };

  public constructor(
    uid: number,
    type: string,
    label: string,
    tag: string,
    devices?: number[],
    totalDevice?: number,
    totalUsedDevice?: number
  ) {
    this.uid = uid;
    this.type = type;
    this.devices = devices || [];
    this.label = label;
    this.tag = tag;
    this.totalDevice = totalDevice || 0;
    this.totalUsedDevice = totalUsedDevice || 0;
  }
}
